import React from 'react';
import { Helmet } from 'react-helmet';
import TextAndImageComp from './components/TextAndImageComp';
import Spotlight from '../../components/organisms/Spotlight';
import challengeAlaska from '../../assets/images/about_screen/community_impact_screen/challenge_alaska.jpg';
import sofaImage from '../../assets/images/about_screen/community_impact_screen/sofa_image.jpg';
import balloonsImage from '../../assets/images/about_screen/community_impact_screen/balloons_image.jpg';
import teacherWithStudents from '../../assets/images/about_screen/community_impact_screen/teacher_with_students.jpg';
import universityPartnership from '../../assets/images/about_screen/community_impact_screen/university_partnership.jpg';
import militaryImage1 from '../../assets/images/about_screen/community_impact_screen/army_family.jpg';
import militaryImage2 from '../../assets/images/about_screen/community_impact_screen/family_voccation.jpg';
import HeroSection from './components/HeroSection';

const AboutUsCommunityImpactPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>
          Community Impact | Guidepost Pediatric Therapies Wasilla Alaska
        </title>
        <meta
          name="description"
          content="Learn how Guidepost Pediatric Therapies impacts the Wasilla, Alaska community through partnerships with Challenge Alaska, Children's Place, reading camps, and military support."
        />
        <meta
          name="keywords"
          content="Guidepost community impact Wasilla, pediatric therapy community Alaska, therapy partnerships Wasilla, community service Alaska"
        />
      </Helmet>
      <HeroSection />
      <TextAndImageComp
        title="How Guidepost is Impacting Our Community"
        subTitle="Challenge Alaska"
        des="Guidepost Pediatrics therapists have been able to partner with Challenge Alaska to assist community members in participating in adaptive sports including mountain biking, skiing, and more."
        bgColor={'bg-white'}
        btnText="Go to Challenge Alaska"
        btnLink={'https://www.challengealaska.org/'}
        imageUrl={challengeAlaska}
        direction="row"
        alt="Child using adaptive equipment in Wasilla occupational therapy"
      />
      <TextAndImageComp
        title=""
        subTitle="Children’s Place"
        des="The Children's Place is a local program that that offers medical evaluation, treatment, and support for victims and families of those affected by sexual violence. Guidepost Pediatrics is proud to support this charity!"
        bgColor={'bg-[#F0EFEF]'}
        btnText="Go to Children’s Place"
        btnLink={'https://thechildrens-place.org/'}
        imageUrl={sofaImage}
        alt="Welcoming waiting room in Wasilla pediatric therapy clinic"
      />
      <TextAndImageComp
        title=""
        subTitle="Community Baby Showers"
        des="We are delighted to partner with ROCK Mat-Su through community baby showers, where our therapists educate parents on crucial developmental milestones and provide information about physical therapy and how to make exercise and developmental play fun."
        bgColor={'bg-white'}
        btnText="Go to Mat-Su Baby"
        btnLink={'https://www.rockmatsu.org/babyshower/'}
        imageUrl={balloonsImage}
        direction="row"
        alt="Wasilla pediatric therapy services promotional banner
"
      />
      <TextAndImageComp
        title=""
        subTitle="Reading Camps"
        des="Guidepost Pediatrics offers an annual reading camp for children in our community. This week-long reading camp includes fun games and learning activities that foster a love for reading, writing, and learning alongside peers and new friends. Reading camp is led by speech therapists and experienced educators to ensure that children are exposed to high-quality and personalized activities targeting speech development, reading comprehension, writing skills, and more. Guidepost Pediatrics does offer some scholarship opportunities for reading camp participation."
        bgColor={'bg-[#F0EFEF]'}
        btnText="Contact Us to Learn More"
        btnLink={'/contact'}
        imageUrl={teacherWithStudents}
        align={'start'}
        alt="Child smiling in Wasilla pediatric therapy session
"
      />
      <TextAndImageComp
        title=""
        subTitle="We Support Our US Military"
        des="Guidepost Pediatric Therapies and Educational Services is honored to serve our military community, and we are thrilled to have the opportunity to connect with the wonderful families and healthcare professionals at JBER pediatrics."
        bgColor={'bg-white'}
        btnText="Visit JBER"
        btnLink={'https://www.jber.jb.mil/'}
        imageUrl={[militaryImage1, militaryImage2]}
        direction={'row'}
        alt="Pediatric therapy team in Wasilla, Alaska clinic
"
      />
      <TextAndImageComp
        title=""
        subTitle="University Partnership"
        des={`
        Guidepost Pediatrics is excited to announce our partnership with universities to allow clinical internship opportunities for physical, occupational, and speech therapy students. Students have the opportunity to learn about our patient population, excel under the direction of our skilled therapists, and serve the community through service projects and community service during their internship experience.
        <br/>
        <br/>
        Contact us today to learn more about clinical internship opportunities.
        `}
        bgColor={'bg-[#F0EFEF]'}
        btnText="Contact Us"
        btnLink={'/contact'}
        imageUrl={universityPartnership}
        align={'start'}
        alt="Smiling pediatric therapist in Wasilla, Alaska clinic"
      />
      <Spotlight />
    </div>
  );
};

export default AboutUsCommunityImpactPage;
